export const tooltipWrapperStyles = {
  display: 'flex',
};

export const wrapperStyles = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  padding: {
    xs: '12px 12px 16px',
    sm: '12px 16px 16px',
    md: '12px 24px 16px',
  },
  width: '100%',
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: ({ palette }) => palette.shadow.m,
  transition: 'background-color 0.1s ease',

  '&.open': {
    backgroundColor: ({ palette }) => palette.background.hoverDefault,
  },
};

export const controlsWrapper = {
  display: 'flex',
  alignItems: 'start',
  flexWrap: 'wrap',
  gap: '16px',
};

export const toolsButtonsWrapper = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
  flexGrow: 1,
  minWidth: 0,
  overflow: 'visible',
};

export const toolButtonStyles = {
  height: '30px',
  minHeight: '30px',
  width: '30px',
  padding: 0,
  borderRadius: '8px',

  '& span': {
    fontWeight: 200,
    fontSize: '2.2rem',
  },
};

// A tenant can configure a dozen grouped action dropdowns. Left unshrinkable, that cluster claims the
// whole row and squeezes the tools cluster to a few dozen pixels, stacking every tool button onto its
// own line — so it must yield width (and, past a full row, wrap onto its own line) instead.
export const groupedActionsWrapper = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
  minWidth: 0,
};

export const drawerStyles = {
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.background.secondary : '#F6F6F6',

  '&.open': {
    backgroundColor: ({ palette }) => palette.background.hoverDefault,
  },
};

export const contentWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  padding: {
    xs: '0 12px',
    sm: '0 16px',
    md: '0 24px',
  },

  '&.open': {
    padding: {
      xs: '2px 12px 42px',
      sm: '2px 16px 42px',
      md: '2px 24px 42px',
    },
  },
};

export const contentTitleStyles = {
  fontWeight: 600,
  color: ({ palette }) => palette.text.primary,
};

export const headerGridWithMoreButtonStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '16px',
  width: '100%',
};

export const moreButtonWrapperStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
  paddingTop: '10px',
};

export const overflowModalContentStyles = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: 'repeat(3, minmax(0, 1fr))',
  },
  columnGap: '20px',
  rowGap: '12px',
  maxHeight: '60vh',
  overflowY: 'auto',
  padding: '8px',
  width: 'min(90vw, 720px)',
};

export const itemStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: '8px',
  minWidth: 0,
};

export const itemTitleStyles = {
  color: ({ palette }) => palette.text.secondary,
  flexShrink: 0,
};

export const itemValueStyles = {
  fontWeight: 700,
  color: ({ palette }) => palette.text.primary,
};

export const searchButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  height: '30px',
  minHeight: '30px',
  padding: '0 8px',
  borderRadius: '8px',
  color: ({ palette }) => palette.text.secondary,

  '&:hover': {
    color: ({ palette }) => palette.text.primary,
  },
};

export const searchShortcutBadgeStyles = {
  padding: '1px 5px',
  borderRadius: '4px',
  backgroundColor: ({ palette }) => palette.background.hoverDefault,
  color: ({ palette }) => palette.text.secondary,
};
